<template>
  <DropDownSelect>
    <template #activator="{ open }">
      <button
        data-testid="single-select-toggle"
        class="flex items-center gap-1 rounded-sm border border-solid border-strong p-2 text-body-s"
        @click.prevent="open"
      >
        <div class="grow text-left">
          {{ selectedOption?.text ?? label }}
        </div>

        <ChevronDownIcon class="lucide-icon-m text-main" />
      </button>
    </template>

    <template #default="{ close }">
      <ul data-testid="single-select-options" class="options-list m-0 list-none overflow-y-auto p-0">
        <li v-for="option in props.options" :key="`filter_${option.value}`" class="separate-rows">
          <button
            class="w-full p-2 text-left whitespace-nowrap text-main hover:bg-surface-elevation-2"
            @click="(handleCheckboxChange(option.value), close())"
          >
            {{ option.text }}
          </button>
        </li>
      </ul>
    </template>
  </DropDownSelect>
</template>

<script setup lang="ts">
import { ChevronDownIcon } from '@ramp106/omrjs-core-ui/icons'
import { computed } from 'vue'
const props = defineProps<{
  modelValue?: string
  options: {
    text: string
    value: string
  }[]
  label: string
}>()

const emit = defineEmits<{
  (e: 'update:modelValue', value: string): void
}>()

const selectedOption = computed(() => {
  return props.options.find((option) => option.value === props.modelValue)
})

const handleCheckboxChange = (optionValue: string) => {
  emit('update:modelValue', optionValue)
}
</script>

<style scoped>
.options-list {
  max-height: min(300px, 40vh);
}
</style>
